module.exports = __webpack_public_path__ + "static/Development.edb171d8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/services/Development.svg
// module id = 362
// module chunks = 35783957827783